// extracted by mini-css-extract-plugin
export default {"alignment":"uxvwEs","title":"fgOEHN","titleNew":"wDH7o8","dateLocation":"b6Z9By","dateLocationNew":"MMb65m"};